import React from "react";
import Navbar from "../Components/Navbar";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";
import QuickLinks from "./QuickLinks";
import FooterNew from "../Components/FooterNew";

const Prescription = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;
  return (
    <div style={{ maxWidth: "100%", overflow: "hidden" }}>
      <Navbar />
      <div className="Main-Header-Container">
        <section
          className="py-xxl-10 pb-0"
          id="home"
          style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
        >
          <div
            className="bg-holder"
            style={{
              backgroundImage: `url(${heroBgImage})`,
              backgroundPosition: "bottom",
              backgroundSize: "cover",

              //   height: "100vh", // Add a height to ensure background is visible
            }}
          />

          <div className="container">
            <div className="row min-vh-xl-100 min-vh-xxl-25">
              <div className=" paddin-header   text-center ">
                <h2 className="">
                  <span
                    className=" general-tittle-mbl"
                    style={{
                      fontSize: "48px",
                      fontFamily: "Raleway, sanf-serif",
                      color: "#fff",
                      paddingBottom: " 10px",
                    }}
                  >
                    Prescription
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div
        className=" about-summary-inline "
        style={{
          marginTop: "80px",
          padding: "5px 10px 0px",
          marginBottom: "100px",
          fontSize: "19px",
          textAlign: "justify",
          lineHeight:"1.6"
        }}
      >
        <p>
          Cost of prescriptions is included within the consultation fee to see
          Dr Ahmed. Replacement prescriptions have an administrative fee of £25,
          and may take up to 10 days as prescriptions are handwritten and posted
          out. Please be aware that pharmacies will charge the full cost of
          medication for private prescriptions, which can often be more than an
          NHS prescription charge.
        </p>
      </div>
      <div className="footer-import  footer-import-contact">
        <QuickLinks />
        <FooterNew />
      </div>
    </div>
  );
};

export default Prescription;
